export class ModificarFactores {
    public Id: number;
    public Factor: string;
    public Riesgo: string;
    public RiesgoId: number;
    public ProbabilidadId: number;
    public Probabilidad: string;
    public Tabla: string;
    public UsuarioId: number;
    public RiesgoEbrId: number;

    constructor(usuarioId) {
        this.RiesgoId = -1;
        this.ProbabilidadId = -1;
        this.UsuarioId = usuarioId;
    }
}
